// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-alert {
  height: 100%;
  width: 100%;
}
.chartkit-alert__container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.chartkit-alert__alert {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 2px;
}
.chartkit-alert__alert_status_OK {
  background-color: var(--g-color-base-positive-medium);
}
.chartkit-alert__alert_status_OK:hover {
  background-color: var(--g-color-base-positive-medium-hover);
}
.chartkit-alert__alert_status_WARN {
  background-color: var(--g-color-base-warning-heavy);
}
.chartkit-alert__alert_status_WARN:hover {
  background-color: var(--g-color-base-warning-heavy-hover);
}
.chartkit-alert__alert_status_ALARM {
  background-color: var(--g-color-base-danger-heavy);
}
.chartkit-alert__alert_status_ALARM:hover {
  background-color: var(--g-color-base-danger-heavy-hover);
}
.chartkit-alert__alert_status_ALARM .chartkit-alert__alert-label,
.chartkit-alert__alert_status_ALARM .chartkit-alert__alert-annotation {
  color: var(--g-color-text-light-primary);
}
.chartkit-alert__alert_status_NO_DATA {
  background-color: var(--g-color-base-generic-medium);
}
.chartkit-alert__alert_status_NO_DATA:hover {
  background-color: var(--g-color-base-generic-medium-hover);
}
.chartkit-alert__alert_status_NO_DATA .chartkit-alert__alert-label,
.chartkit-alert__alert_status_NO_DATA .chartkit-alert__alert-annotation {
  color: var(--g-color-text-primary);
}
.chartkit-alert__alert_status_ERROR {
  border: 1px solid var(--g-color-line-generic);
  background-image: repeating-linear-gradient(-45deg, var(--g-color-base-generic), var(--g-color-base-generic) 8px, transparent 8px, transparent 16px);
}
.chartkit-alert__alert_status_ERROR:hover {
  background-color: var(--g-color-base-simple-hover);
}
.chartkit-alert__alert_status_ERROR .chartkit-alert__alert-label,
.chartkit-alert__alert_status_ERROR .chartkit-alert__alert-annotation {
  color: var(--g-color-text-primary);
}
.chartkit-alert__alert-label, .chartkit-alert__alert-annotation {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1.2;
  text-align: center;
  color: var(--g-color-text-dark-primary);
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/ChartKit/components/Widget/components/AlertWidget/Alert.scss"],"names":[],"mappings":"AAAA;EAGI,YAAA;EACA,WAAA;AADJ;AAGI;EACI,aAAA;EACA,eAAA;EACA,uBAAA;AADR;AAII;EACI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EAAA,qBAAA;EACA,sBAAA;EAEA,kBAAA;EACA,WAAA;AAHR;AAKQ;EACI,qDAAA;AAHZ;AAKY;EACI,2DAAA;AAHhB;AAMQ;EACI,mDAAA;AAJZ;AAMY;EACI,yDAAA;AAJhB;AAOQ;EACI,kDAAA;AALZ;AAOY;EACI,wDAAA;AALhB;AAQY;;EAEI,wCAAA;AANhB;AASQ;EACI,oDAAA;AAPZ;AASY;EACI,0DAAA;AAPhB;AAUY;;EAEI,kCAAA;AARhB;AAWQ;EACI,6CAAA;EACA,oJAAA;AATZ;AAiBY;EACI,kDAAA;AAfhB;AAkBY;;EAEI,kCAAA;AAhBhB;AAqBI;EAEI,WAAA;EAEA,mBAAA;EACA,uBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,uCAAA;AAtBR","sourcesContent":[".chartkit-alert {\n  height: 100%;\n  width: 100%;\n}\n.chartkit-alert__container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.chartkit-alert__alert {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  justify-content: center;\n  text-decoration: none;\n  box-sizing: border-box;\n  border-radius: 4px;\n  margin: 2px;\n}\n.chartkit-alert__alert_status_OK {\n  background-color: var(--g-color-base-positive-medium);\n}\n.chartkit-alert__alert_status_OK:hover {\n  background-color: var(--g-color-base-positive-medium-hover);\n}\n.chartkit-alert__alert_status_WARN {\n  background-color: var(--g-color-base-warning-heavy);\n}\n.chartkit-alert__alert_status_WARN:hover {\n  background-color: var(--g-color-base-warning-heavy-hover);\n}\n.chartkit-alert__alert_status_ALARM {\n  background-color: var(--g-color-base-danger-heavy);\n}\n.chartkit-alert__alert_status_ALARM:hover {\n  background-color: var(--g-color-base-danger-heavy-hover);\n}\n.chartkit-alert__alert_status_ALARM .chartkit-alert__alert-label,\n.chartkit-alert__alert_status_ALARM .chartkit-alert__alert-annotation {\n  color: var(--g-color-text-light-primary);\n}\n.chartkit-alert__alert_status_NO_DATA {\n  background-color: var(--g-color-base-generic-medium);\n}\n.chartkit-alert__alert_status_NO_DATA:hover {\n  background-color: var(--g-color-base-generic-medium-hover);\n}\n.chartkit-alert__alert_status_NO_DATA .chartkit-alert__alert-label,\n.chartkit-alert__alert_status_NO_DATA .chartkit-alert__alert-annotation {\n  color: var(--g-color-text-primary);\n}\n.chartkit-alert__alert_status_ERROR {\n  border: 1px solid var(--g-color-line-generic);\n  background-image: repeating-linear-gradient(-45deg, var(--g-color-base-generic), var(--g-color-base-generic) 8px, transparent 8px, transparent 16px);\n}\n.chartkit-alert__alert_status_ERROR:hover {\n  background-color: var(--g-color-base-simple-hover);\n}\n.chartkit-alert__alert_status_ERROR .chartkit-alert__alert-label,\n.chartkit-alert__alert_status_ERROR .chartkit-alert__alert-annotation {\n  color: var(--g-color-text-primary);\n}\n.chartkit-alert__alert-label, .chartkit-alert__alert-annotation {\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  line-height: 1.2;\n  text-align: center;\n  color: var(--g-color-text-dark-primary);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
